export const PROD = 'prod';
export const VERIF = 'verif';
export const TRAD = 'trad';

export const MODES = [PROD, VERIF, TRAD];
